<div class="col-12 offset-lg-2 col-lg-8 hup-subscription-terminate">
  <h3 class="hup-subscription-terminate__headline"
    *appApplyIfNotEmpty="translationService.getTranslation('headline_terminate')"
    [innerHTML]="translationService.getTranslation('headline_terminate')"></h3>
</div>
<div class="col-12 offset-lg-2 col-lg-8 mb-5 hup-subscription-terminate__intro"
  [innerHTML]="translationService.getTranslation('terminate_intro')"></div>

@if (isLoading) {
  <div class="hup-subscription-terminate__loading" style="text-align: center;">
    <app-loading-spinner/>
  </div>
} @else {
  @if (terminationTypes) {
    <form class="col-12 offset-lg-2 col-lg-8 hup-subscription-terminate__form" [formGroup]="terminationForm">
      @if (subscriptionHasCommitment && showDefaultTerminationWarning && terminationWarning) {
        <app-general-warning [warnings]="[{infoText: terminationWarning}]"></app-general-warning>
      }
      <mat-form-field class="hup-subscription-terminate__form-field">
        <mat-label
          class="hup-subscription-terminate__form-label"
          [innerHTML]="translationService.getTranslation('terminate_reason')"
        ></mat-label>        <mat-select
          class="hup-subscription-terminate__form-select"
          formControlName="reason"
          required
          aria-required="true"
          [value]="terminationForm.get('reason').value"
        >
          @for (terminationType of terminationTypes; track terminationType) {
            @if (terminationType.useInFE) {
              <mat-option
                class="hup-subscription-terminate__form-option"
                [value]="terminationType"
              >{{ terminationType.description }}
              </mat-option
              >
            }
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field
        class="hup-subscription-terminate__form-field"
        (click)="picker1.open()"
      >
        <mat-label
          class="hup-subscription-terminate__form-label"
          [innerHTML]="translationService.getTranslation('terminate_date')"
        ></mat-label>
        <input
          class="hup-subscription-terminate__form-input"
          matInput
          [min]="minDate"
          [matDatepicker]="picker1"
          readonly
          formControlName="terminationDate"
        />
        <mat-datepicker-toggle
          class="hup-subscription-terminate__form-datepicker-toggle"
          matSuffix
          [for]="picker1"
        ></mat-datepicker-toggle>
        <mat-datepicker
          class="hup-subscription-terminate__form-datepicker"
          [touchUi]="false"
          #picker1
          disabled="false"
        ></mat-datepicker>
      </mat-form-field>
      <div class="hup-subscription-terminate__form-actions">
        <button
          class="hup-subscription-terminate__form-submit"
          mat-raised-button
          [disabled]="!terminationForm.valid"
          (click)="terminateSubscription()"
          [innerHTML]="translationService.getTranslation('button_terminate')"
        ></button>
      </div>
    </form>
  }
  <div class="col-12 offset-lg-2 col-lg-8 mt-3 text-end hup-subscription-terminate__back">
    @if (showBackToOverviewButton) {
      <button
        class="hup-subscription-terminate__back-button"
        mat-raised-button
        (click)="backToOverview()"
        [innerHTML]="translationService.getTranslation('button_back_to_overview')"
      ></button>
    }
  </div>
}
